import { render, staticRenderFns } from "./ContactPageComponent.vue?vue&type=template&id=2538757a&scoped=true&"
import script from "./ContactPageComponent.vue?vue&type=script&lang=js&"
export * from "./ContactPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538757a",
  null
  
)

export default component.exports